import React, {useState, useEffect} from 'react';
import ImageGallery from 'react-image-gallery';
import {Select, Pagination, Divider} from 'antd';
import {getMethod} from '../services/methods';
import getStateList from "../utils/stateList";

const {Option} = Select;

export default function Photos() {
    const [stateList] = useState(getStateList().data)
    const [selectedState, setSelectedState] = useState(getStateList().data[0].il_adi);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const handleTableChange = async (currentPage) => {
        setLoading(true)
        const taskImages = [];
        const userData = await getMethod(`/task/photos/${pagination.pageSize}/${pagination.pageSize * (currentPage - 1)}?state=${selectedState}`);
        userData.list.map(task => {
            task.data.photo.map(photo => {
                if (photo?.url) {
                    taskImages.push({original: photo?.url, thumbnail: photo?.url});
                }
            })
        })
        setImages(taskImages);
        setPagination(userData.pagination);
        setLoading(false)
    };

    useEffect(() => {
        handleTableChange(1);
    }, [selectedState])


    return (
        <>
            <Select
                style={{minWidth: 200, marginBottom: 10}}
                onChange={(value) => {
                    setSelectedState(value);
                }}
                autoComplete="off"
                value={selectedState}
                showSearch
                optionFilterProp="children"
                allowClear
                filterOption={(input, option) =>
                    option.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children.toLocaleLowerCase('tr').localeCompare(optionB.children.toLocaleLowerCase('tr'))
                }
            >
                {
                    stateList.map(item => (
                        <Option key={item.il_adi} value={item.il_adi}>{item.il_adi}</Option>
                    ))
                }
            </Select>
            {images.length > 0 ?
                <>
                    <ImageGallery items={images}/>
                    <Pagination onChange={handleTableChange} pageSize={pagination.pageSize} total={pagination.total}/>
                </> : <Divider>Veri Yok</Divider>
            }
        </>
    )
}
